import React, { useState, useEffect } from "react";
import { Box, Divider, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Controls from "../../Component/controls/Controls";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import { useSnackbar } from "notistack";

import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useNavigate, useLocation } from "react-router";
import {
  addCityByState,
  updateCityLocation,
} from "../../state/action/locationAction";
import { useForm, Form } from "../../Utils/useForm";
const initialValues = {
  name: "",
};

function AddCity() {
  const [value, setValue] = useState("1");
  const [isEdit, setIsEdit] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { state } = useLocation();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "This field is required.";

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValues, true, validate);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        stateId: state.stateId,
        name: values.name,
      };
      if (isEdit) {
        // updateProduct(formData, state.product._id);
        const res = await updateCityLocation(state.data.id, payload);
        if (res && res.status === true) {
          navigate("/City", {
            state: {
              countryId: state.stateId,
              name: state.stateName,
            },
          });
          enqueueSnackbar(res.message, {
            variant: "success",
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
            autoHideDuration: 2000,
          });
        }
      }

      if (!isEdit) {
        const res = await addCityByState(payload);
        if (res && res.status === true) {
          navigate("/City", {
            state: {
              countryId: state.stateId,
              name: state.stateName,
            },
          });
          enqueueSnackbar(res.message, {
            variant: "success",
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
            autoHideDuration: 2000,
          });
        }
      }
    }
  };

  useEffect(() => {
    if (
      state?.data?.id != "" &&
      state?.data?.id != null &&
      state?.data?.id != undefined
    ) {
      setIsEdit(true);
      setValues({
        ...values,
        name: state?.data?.name,
      });
    }
  }, [state]);
  return (
    <>
      <Box>
        <Box
          sx={{
            px: 3,
            paddingBottom: "3px",
            backgroundColor: "rgb(241, 245, 249)",
          }}
        >
          <Typography
            sx={{
              paddingTop: "25px",
              paddingBottom: "15px",
              fontSize: "15px",
              fontWeight: "600",
              color: "#000",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/City", {
                state: {
                  countryId: state.stateId,
                  name: state.stateName,
                },
              });
            }}
          >
            <KeyboardBackspaceIcon
              sx={{ verticalAlign: "top", marginRight: "5px" }}
            />
            City
          </Typography>
          <Grid container alignItems="top" style={{ marginBottom: "20px" }}>
            <Grid item sm={6} xs={12}>
              <Box display="flex">
                <Box>
                  <img
                    src={"../../assets/images/product-image.png"}
                    style={{ borderRadius: "5px" }}
                  />
                </Box>
                <Box sx={{ marginLeft: "10px" }}>
                  <Typography
                    sx={{ fontSize: "18px", fontWeight: "600", color: "#000" }}
                  >
                    {isEdit ? "Edit City" : "Add City"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#000",
                      marginTop: "3px",
                    }}
                  >
                    City
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Box
                display="flex"
                sx={{
                  justifyContent: {
                    xs: "block",
                    sm: "flex-end",
                    md: "flex-end",
                    lg: "flex-end",
                  },
                  marginTop: { xs: "20px", md: "0", lg: "0" },
                }}
              >
                <Controls.Button
                  text="Cancel"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#fff",
                    backgroundColor: "red",
                    ":hover": { bgcolor: "red" },
                    textTransform: "none",
                    borderRadius: "50px",
                    boxShadow: 0,
                  }}
                  onClick={() => {
                  }}
                />
                <Controls.Button
                  text="Save"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#fff",
                    backgroundColor: "rgb(79, 70, 229)",
                    ":hover": { bgcolor: "rgb(79, 70, 229)" },
                    marginLeft: "10px",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    textTransform: "none",
                    borderRadius: "50px",
                  }}
                  variant="outlined"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            backgroundColor: "rgb(241, 245, 249)",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              borderTopRightRadius: "20px",
              borderTopLeftRadius: "20px",
              border: 1,
              borderColor: "#eaeaea",
              paddingLeft: "0px",
              paddingTop: "10px",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <TabContext value={value}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "rgba(107, 114, 128, .4)",
                    marginBottom: "0px",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label="Add City"
                      value="1"
                      sx={{
                        color: "rgb(107, 114, 128)",
                        fontSize: "14px",
                        fontWeight: "500",
                        textTransform: "none",
                      }}
                    />
                    {/*<Tab label="Upload Img" value="2" sx={{ color:'rgb(107, 114, 128)',fontSize: "14px", fontWeight:'500',textTransform: "none" }}/>  */}
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Form onSubmit={handleSubmit}>
                    <Box
                      display={"flex"}
                      gap={2}
                      sx={{
                        width: {
                          md: "100%",
                          lg: "600px",
                        },
                      }}
                    >
                      <Controls.Input
                        text="Add New"
                        variant="outlined"
                        color="primary"
                        label="City"
                        sx={{ color: "#000", borderColor: "#000", border: "1" }}
                        name="name"
                        onChange={handleInputChange}
                        value={values.name}
                        error={errors.name}
                      />
                    </Box>
                  </Form>
                </TabPanel>
                {/*<TabPanel value="2">
     <Box>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    ":hover": { bgcolor: "transparent" },
                    textTransform: "none",
                    fontSize: "16px",
                    backgroundColor: "#f6f9fb",
                    borderRadius: "15px",
                    padding: "40px",
                  }}
                >
                  <DriveFolderUploadIcon
                    sx={{
                      fontSize: "40px",
                      color: "rgb(107, 114, 128)",
                      display: "flex",
                    }}
                  />
                 
                </Button>
                <Typography
                  sx={{ fontSize: "13px", color: "#000", marginTop: "7px" }}
                >
                  Category Image
                </Typography>
              </Box>
     </TabPanel> */}
              </TabContext>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default AddCity;
